export default "__VITE_ASSET__8623288f__"